import { Empty } from "antd";
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { usePagination, useSortBy, useTable } from "react-table";
import { toast } from "react-toastify";
import { deleteEmployee } from "../../../lib/deleteEmployee";
import { getEmployees } from "../../../lib/getEmployees";
import DeleteReasonModal from "./DeleteleEmployeeReasonModal";
import EditEmployee from "./EditEmployee";

const deleteSuccess = () => {
  toast.success("✔️ Empleado eliminado correctamente.", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const deleteFail = () => {
  toast.error("✗ Ha ocurrido un error al intentar borrar.", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const EmployeeTable = ({ data=[], setEmployeeList }) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const columns = useMemo(
    () => [
      {
        Header: "Apellido y Nombre",
        accessor: "name",
      },
      {
        Header: "DNI",
        accessor: "dni",
      },
      {
        Header: "Teléfono",
        accessor: "phoneNumber",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      { Header: "Tipo Aporte", 
        accessor: "tipo_aporte" 
      },
      {
        Header: "Ingreso Bruto",
        accessor: "salary",
      },
      {
        Header: " ",
        disableSortBy: true,
        Cell: (props) => (
          <div className="d-flex justify-content-end">
            <Link
              to={"#"}
              onClick={() => {
                setOpenEdit(true);
                setSelectedEmployee(props?.row?.original);
              }}
              className="btn btn-primary shadow btn-xs sharp me-3"
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            <Link
            to={"#"}
            className="btn btn-danger shadow btn-xs sharp"
            onClick={() => {
              setEmployeeToDelete(props?.row?.original);
              setDeleteModalVisible(true);
            }}
          >
            <i className="fa fa-trash"></i>
          </Link>
          </div>
        ),
      },
    ],

    []
  );

  const tableInstance = useTable(
    { columns, data, initialState: { pageSize: 10 } },
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  } = tableInstance;
 
  return (
    <>
      {!data || (data && data.length < 1) ? (
        <Empty
          style={{ marginTop: "10%" }}
          description="No hay empleados cargados."
          // image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => {
                        return (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                          >
                            {column.render("Header")}
                            {column.Header === "Apellido y Nombre" && (
                              <span className="ml-1">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            )}
                          </th>
                        );
                      })}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}{" "}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <EditEmployee
            setEmployeeList={setEmployeeList}
            openDrawer={openEdit}
            setOpenDrawer={setOpenEdit}
            selectedEmployee={selectedEmployee}
            setSelectedEmployee={setSelectedEmployee}
          />
          <DeleteReasonModal
              visible={deleteModalVisible}
                onClose={() => {
                  setDeleteModalVisible(false);
                  setEmployeeToDelete(null);
                }}
                onConfirm={async (reason) => {
                  if (!employeeToDelete) return;

                  const { companyProfile, email: deletedBy } = JSON.parse(window.localStorage.getItem("userDetails"));
                  const payload = {
                    idEmployee: employeeToDelete._id,
                    reason,
                    deletedBy,
                  };
debugger
                  await deleteEmployee(payload).then((res) => {
                    const { status } = res.data;
                    if (status) {
                      deleteSuccess();
                      getEmployees(companyProfile._id).then((res) => {
                        setEmployeeList(res.data);
                      });
                    } else {
                      deleteFail();
                    }
                  });

                  setDeleteModalVisible(false);
                  setEmployeeToDelete(null);
                }}
              />

        </div>
      )}
    </>
  );
};

export default EmployeeTable;
